import axios from "axios";
import { API_BASE_URL, getAuthConfig } from "./apiClient";

export const fetchPolicy = async () => {
  const response = await axios.get(`${API_BASE_URL}/policy`);
  return response.data;
};

export const uploadPolicy = async (policyPayload) => {
  const response = await axios.post(
    `${API_BASE_URL}/policy/upload`,
    policyPayload,
    getAuthConfig(),
  );

  return response.data;
};
